import type { DeployPluginEntry, DeployTypeCode, DeployTypePluginHeadless, PluginUi } from './types';

type UiLoader = DeployPluginEntry['loadUi'];

const HEADLESS_ENTRIES: Partial<Record<DeployTypeCode, DeployTypePluginHeadless>> = {};
const UI_LOADERS: Partial<Record<DeployTypeCode, UiLoader>> = {};

export function registerDeployPlugin(entry: DeployPluginEntry): void {
  const { code } = entry.headless;
  HEADLESS_ENTRIES[code] = entry.headless;
  UI_LOADERS[code] = entry.loadUi;
}

export function registerDeployPluginHeadless(headless: DeployTypePluginHeadless): void {
  HEADLESS_ENTRIES[headless.code] = headless;
}

export function registerDeployPluginUi(code: DeployTypeCode, loadUi: UiLoader): void {
  UI_LOADERS[code] = loadUi;
}

export function getDeployPluginHeadless(code: DeployTypeCode): DeployTypePluginHeadless {
  const plugin = HEADLESS_ENTRIES[code];
  if (!plugin) {
    throw new Error(`Deploy plugin headless not registered: ${code}`);
  }
  return plugin;
}

export async function loadDeployPluginUi(code: DeployTypeCode): Promise<PluginUi> {
  const loader = UI_LOADERS[code];
  if (!loader) {
    throw new Error(`Deploy plugin UI loader not registered: ${code}`);
  }
  return loader();
}

/** 是否已 `registerDeployPlugin`（读 registry）。`SharedVolume` 为 false，见 `UNREGISTERED_DEPLOY_TYPE_CODES`。 */
export function isPluginDeployType(code?: string): code is DeployTypeCode {
  return code != null && code in HEADLESS_ENTRIES;
}

export function listRegisteredDeployPlugins(): DeployTypeCode[] {
  return Object.keys(HEADLESS_ENTRIES) as DeployTypeCode[];
}
